import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { firstName, lastName } from './common-steps'
import {
  addressLocationLead,
  addressLocationLeadMektel,
  choiceInternetMobileTv,
  chooseChannels,
  choosePhonePlan,
  configurationTV,
  confirmLead,
  currentProviderInternetLead,
  currentProviderMobileLead,
  currentProviderMobileLeadC,
  emailAddressLead,
  emailAddressLeadC,
  emailAddressLeadCC,
  emailAddressLeadMektel,
  finalWordLeadMektel,
  firstNameMektel,
  installationDatePicker,
  lastNameMektel,
  newClientVerification,
  phoneNumberLead,
  phoneNumberLeadB,
  phoneNumberLeadMektel,
  phoneResidentialLeadMektel,
  providerAvailability,
  selectCurrentProviderLeadMektel,
  serviceTransferSelected,
  // startLead,
  thanksLead,
  transferringService,
  transferInternet,
} from './lead-steps'

export const leadMobileScenarioA: Scenario = {
  id: 'lead-mobile-a',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_MOBILE,
  version: '1',
  milestones: [
    // startLead.id,
    emailAddressLead.id,
    addressLocationLead.id,
    providerAvailability.id,
    firstName.id,
    lastName.id,
    phoneNumberLead.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    // startLead,
    emailAddressLead,
    addressLocationLead,
    providerAvailability,
    firstName,
    lastName,
    phoneNumberLead,
    confirmLead,
    thanksLead,
  ],
  weight: 0,
}

export const leadInternetScenarioA: Scenario = {
  id: 'lead-internet-a',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_INTERNET,
  version: '1',
  milestones: [
    // startLead.id,
    emailAddressLead.id,
    addressLocationLead.id,
    providerAvailability.id,
    firstName.id,
    lastName.id,
    phoneNumberLead.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    // startLead,
    emailAddressLead,
    addressLocationLead,
    providerAvailability,
    firstName,
    lastName,
    phoneNumberLead,
    confirmLead,
    thanksLead,
  ],
  weight: 0,
}

export const leadMobileScenarioB: Scenario = {
  id: 'lead-mobile-b',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_MOBILE,
  version: '1',
  milestones: [
    // startLead.id,
    emailAddressLead.id,
    addressLocationLead.id,
    providerAvailability.id,
    firstName.id,
    lastName.id,
    phoneNumberLeadB.id,
    currentProviderMobileLead.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    // startLead,
    emailAddressLead,
    addressLocationLead,
    providerAvailability,
    firstName,
    lastName,
    phoneNumberLeadB,
    currentProviderMobileLead,
    confirmLead,
    thanksLead,
  ],
  weight: 0,
}

export const leadInternetScenarioB: Scenario = {
  id: 'lead-internet-b',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_INTERNET,
  version: '1',
  milestones: [
    // startLead.id,
    emailAddressLead.id,
    addressLocationLead.id,
    providerAvailability.id,
    firstName.id,
    lastName.id,
    phoneNumberLeadB.id,
    currentProviderMobileLead.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    // startLead,
    emailAddressLead,
    addressLocationLead,
    providerAvailability,
    firstName,
    lastName,
    phoneNumberLeadB,
    currentProviderMobileLead,
    confirmLead,
    thanksLead,
  ],
  weight: 0,
}

export const leadMobileScenarioC: Scenario = {
  id: 'lead-mobile-c',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_MOBILE,
  version: '1',
  milestones: [
    // startLead.id,
    emailAddressLeadC.id,
    currentProviderMobileLeadC.id,
    newClientVerification.id,
    addressLocationLead.id,
    providerAvailability.id,
    firstName.id,
    lastName.id,
    phoneNumberLead.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    // startLead,
    emailAddressLeadC,
    currentProviderMobileLeadC,
    newClientVerification,
    addressLocationLead,
    providerAvailability,
    firstName,
    lastName,
    phoneNumberLead,
    confirmLead,
    thanksLead,
  ],
  weight: 1,
}

export const leadInternetScenarioC: Scenario = {
  id: 'lead-internet-c',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_INTERNET,
  version: '1',
  milestones: [
    // startLead.id,
    emailAddressLeadCC.id,
    currentProviderInternetLead.id,
    newClientVerification.id,
    addressLocationLead.id,
    providerAvailability.id,
    firstName.id,
    lastName.id,
    phoneNumberLeadB.id,
    currentProviderMobileLead.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    // startLead,
    emailAddressLeadCC,
    currentProviderInternetLead,
    newClientVerification,
    addressLocationLead,
    providerAvailability,
    firstName,
    lastName,
    phoneNumberLeadB,
    currentProviderMobileLead,
    confirmLead,
    thanksLead,
  ],
  weight: 1,
}

export const leadInternetMektelScenario: Scenario = {
  id: 'lead-internet-mektel',
  initialStep: Steps.EMAIL_ADDRESS_LEAD,
  type: ScenarioType.LEAD_INTERNET,
  version: '1',
  milestones: [
    emailAddressLeadMektel.id,
    choiceInternetMobileTv.id,
    transferringService.id,
    installationDatePicker.id,
    addressLocationLeadMektel.id,
    firstNameMektel.id,
    lastNameMektel.id,
    phoneNumberLeadMektel.id,
    finalWordLeadMektel.id,
    confirmLead.id,
    thanksLead.id,
  ],
  steps: [
    emailAddressLeadMektel,
    choiceInternetMobileTv,
    choosePhonePlan,
    configurationTV,
    chooseChannels,
    transferringService,
    installationDatePicker,
    selectCurrentProviderLeadMektel,
    serviceTransferSelected,
    phoneResidentialLeadMektel,
    transferInternet,
    addressLocationLeadMektel,
    firstNameMektel,
    lastNameMektel,
    phoneNumberLeadMektel,
    finalWordLeadMektel,
    confirmLead,
    thanksLead,
  ],
  weight: 1,
}
